"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResults = exports.default = void 0;
var no_results_component_1 = require("./no-results.component");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(no_results_component_1).default; } });
Object.defineProperty(exports, "NoResults", { enumerable: true, get: function () { return no_results_component_1.NoResults; } });
